/**
 * @desc        Store Manager
 * @version     1.1 (updated redux-persist) - 16 Sept 24 **/

import storage from 'localforage'
import { combineReducers, createStore } from 'redux'
import { persistReducer } from 'redux-persist'

//TODO: look to see if can whitelist only some lower parts of the state
const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['theme', 'awsut', 'gpevents', 'weather', 'paddocks'],
    whitelist: ['account', 'assets', 'livestock', 'users', 'livestock2', 'farmEvents', 'paddocks'],
    // Do not rehydrate weather, in case the old Dark Sky format was stored
    migrate: state =>
        Promise.resolve({
            ...state,
            aws: {
                ...(state?.aws || {}),
                loading: false,
            },
            weather: undefined,
        }),
    debug: false, // Enable debugging
}
export const StoreManager = {
    store: null,
    reducerMap: {},
    registerReducers(newReducerMap) {
        if (Object.entries(this.reducerMap).length === 0 && this.reducerMap.constructor === Object) {
            this.reducerMap = newReducerMap
        } else {
            this.reducerMap = { ...this.reducerMap, ...newReducerMap }
            this.store.replaceReducer(combineReducers(this.reducerMap))
        }
    },
    createStore(...args) {
        const reduxPersistReducer = persistReducer(persistConfig, combineReducers(this.reducerMap))
        this.store = createStore(reduxPersistReducer, ...args)
        return this.store
    },
}

export default StoreManager
